// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__lUWJe","text":"delete-modal_text__GKQYB","source":"delete-modal_source__EInwm","button":"delete-modal_button__6AONz"};